import type React from 'react'
import type { Theme } from '../contexts/ThemeContext'
import type { Brand, ResolvedBrand } from '../types/project'

/** Flattens a brand against the active theme. */
export function resolveBrand(brand: Brand, theme: Theme): ResolvedBrand {
  const palette = theme === 'light' ? brand.light : brand.dark
  return {
    logo: brand.logo,
    site: brand.site,
    radius: brand.radius,
    displayFont: brand.displayFont,
    bodyFont: brand.bodyFont,
    displayUppercase: brand.displayUppercase,
    ...palette,
  }
}

/** Exposes a resolved brand as CSS variables so components can theme with var() classes. */
export function brandVars(brand: ResolvedBrand): React.CSSProperties {
  return {
    '--b-bg': brand.bg,
    '--b-surface': brand.surface,
    '--b-surface-alt': brand.surfaceAlt,
    '--b-border': brand.border,
    '--b-text': brand.text,
    '--b-dim': brand.textDim,
    '--b-accent': brand.accent,
    '--b-on-accent': brand.onAccent,
    '--b-tint': brand.tint,
    '--b-radius': brand.radius,
    '--b-display': brand.displayFont,
    '--b-body': brand.bodyFont,
  } as React.CSSProperties
}
